







import Vue from "vue";
import { ETechnicalError } from "@exp/vue";

export default Vue.extend({
    name: "TechnicalError",
    components: { ETechnicalError },
    data() {
        return {
            currentErrorComponent: "e-technical-error",
        };
    },
});
